import React from "react";
import "antd/dist/antd.css";
import Top from "../../../components/common/Top";
import Footer from "../../../components/common/Footer";
import ContactModel from "../../../components/common/ContactModel";
import FreeTrial from "../../../components/FreeTrial";
import Banner from "../common/Banner";
import ClientCase from "../common/ClientCase";
import { Layout } from "antd";
import actionWays from "../../../redux/actions";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";
import "../../../inphone.scss";
import ServiceValue from "../common/ServiceValue";
import DiverseScenarios from '../SpaceOperations/DiverseScenarios';
import ProductSolutions from "./ProductSolutions";
import KernelModule from "./KernelModule";
import { adaptation } from "../../../utils/adaptation";
import "../common/index.scss";
const { Content } = Layout;
const bannerObj = {
  imgUrl: require("../../../assets/images/solution/common/banner3.png").default,
  name: "惠联档案一体化智能服务平台",
  title: "空间运营管理数智化",
  details: "科学、智能、安全的空间运营数智化解决方案",
};
const anchorPointList = [
  { name: "解决方案", link: "customized_id" },
  { name: "产品介绍", link: "productCenter_id" },
  { name: "部署方式", link: "deliver_id" },
  { name: "客户案例", link: "clientCase_id" },
];
const customized = {
  til: "核心优势",
  // dil: "盘清资产家底，掌握经营效益，加强资产监管",
  imgUrl:
    require("../../../assets/images/solution/spaceOperations/customized.png")
      .default,
  // back: "#f7fafd",
  margin: "70px",
};
const productSolutionsObj = {
  til: "产品方案",
  dil: "私人定制量身打造存量资产管理解决方案",
  imgUrl: "",
  back: "#f7fafd",
  margin: "70px",
  list: [
    {
      // imgUrl: require("../../../assets/images/solution/common/1.png").default,
      title: "空间安行",
      chiderList: [
        "数智通行，实现智能、高效、安全通行管理",
        "数智访问，提供数智访问，实现访客自助与移动应用联动",
        "安防预警，集成安防预警，智能巡更，确保安全",
      ],
      backColor: "",
    },
    {
      // imgUrl: require("../../../assets/images/solution/common/1.png").default,
      title: "空间沟通",
      chiderList: [
        "会议无纸化与签到门控，提升沟通效率",
        "数字会议助手，简化会议流程",
        "会议资源柜与数字慧屏，增强会议体验",
      ],
      backColor: "",
    },
    {
      // imgUrl: require("../../../assets/images/solution/common/1.png").default,
      title: "空间传播",
      chiderList: [
        "数字展厅与展示，创新企业文化传播",
        "交互媒体与数字云传播，提升品牌形象",
      ],
      backColor: "",
    },
    {
      // imgUrl: require("../../../assets/images/solution/common/1.png").default,
      title: "空间孪生",
      chiderList: [
        "空间运营一体化管理平台，提升管理效能",
        "一步式策略联动，减少运营成本",
        "空间交互可视化，映射至数字世界",
      ],
      backColor: "",
    },
  ],
};
class Guaranteed extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      publicList: [],
      projectList: [],
      projectName: "",
    };
  }
  componentDidMount() {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    adaptation();
  }
  render() {
    const { t } = this.props;
    const electronicContent1 = t("spaceOperations.space_part2", {
      returnObjects: true,
    });
    const electronicContent2 = t("spaceOperations.space_part4", {
      returnObjects: true,
    });
    return (
      <Layout>
        <Top />
        {/* <ContactModel /> */}
        <Content id="contentId">
          {/* banner图 start*/}
          <Banner bannerObj={bannerObj} active={3}/>
          {/* banner图 end*/}
          {/* 锚点 start*/}
          {/* <AnchorPoint anchorPointList={anchorPointList} /> */}
          {/* 锚点 end*/}
          {/* 服务价值 start*/}
          <ServiceValue
            electronicContent={electronicContent1}
            styleContent={{width:'1300px'}}
          />
          {/* 服务价值 end*/}
          {/* 核心模块 start */}
          <KernelModule />
          {/* 核心模块 end */}
          {/* 理由模块 start */}
          <ServiceValue
            electronicContent={electronicContent2}
            styleContent={{width:'1000px'}}
          />
          {/* 理由模块 end */}
          {/* 应用场景 start */}
          <DiverseScenarios />
          {/* 应用场景 end */}
          {/* 产品方案 start */}
          {/* <ProductSolutions productSolutionsObj={productSolutionsObj} /> */}
          {/* 产品方案 end */}
          {/* 客服 start*/}
          {/* <ClientCase /> */}
          {/* 客户服务 end*/}
          {/* 在线体验 start*/}
          <FreeTrial />
          {/* 在线体验 end*/}
          <Footer />
        </Content>
      </Layout>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    userLoginInfo: state.userLoginInfo,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    saveLoginInfo: (...args) => dispatch(actionWays.saveLoginInfo(...args)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(withTranslation()(Guaranteed)));
